import React from "react";

const UserRight = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M17.232 21.224v11.683H4a11.785 11.785 0 013.982-8.832 11.76 11.76 0 019.25-2.851zm-1.47-1.563c-4.874 0-8.822-3.952-8.822-8.83C6.94 5.95 10.888 2 15.761 2c4.874 0 8.822 3.952 8.822 8.83 0 4.88-3.948 8.83-8.822 8.83zm8.516 10.175l5.197-5.202 2.08 2.08L24.279 34l-5.198-5.204 2.08-2.081 3.117 3.122h.001z"
          fill={fill}
      />
    </svg>
);

export default UserRight;
